<template>
  <section class="cool-popup" :class="popup.class || ''">
    <transition name="popup">
      <div class="popup-main" v-if="animationShow">
        <div class="mask"  @click="hide('mask')">
        </div>
        <div class="popup-wrap"  :class="popup.wrapClass || ''">
          <div class="close-btn" v-if="popup.closeBtn" @click="hide('btn')">
            <i class="iconfont etc-icon-close"></i>
          </div>
          <slot name="content">
          </slot>
        </div>

      </div>

    </transition>
  </section>
</template>

<script>
export default {
  name: 'popup',
  components: {},
  data() {
    return {
      animationShow: false,
      popup: {
      }
    }
  },
  computed: {},
  methods: {
    hide(type) {
      if (type === 'mask' && !this.popup.maskHide) return
      this.animationShow = false
      this.$emit('popupHide')
    }
  },
  mounted() {
    this.$on('showPopup', popup => {
      if (this.animationShow) return
      Object.assign(this.popup, popup)
      this.animationShow = true
      // console.log('showPopup', this.popup)
    })
    this.$on('hidePopup', data => {
      this.hide()
    })
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.cool-popup {
  .popup-main {
    width: 100vw;
    height: 100vh;
    @extend %flex-center;
    position: fixed;
    top: 0;
    left: 0;
  }
  .mask{
    @extend %all-mask;
  }
  .popup-wrap{
    z-index: 100;
    position: fixed;
    //@extend %absolute-center;
    width: 640px;
    background-color: #fff;
    border-radius: 10px;
    position: relative;
    .close-btn{
      position: absolute;
      top: 0;
      right: 0;
      padding: 20px 30px;
      i{
        font-size: 30px;
        color: #999999;
      }
    }
    &.wrap-trans {
      width: auto;
      background-color: transparent;
      border-radius: 0;
    }
  }
  .popup-enter-active, .popup-leave-active {
    transition: opacity .3s;
    .popup-wrap{
      /*transition: transform .4s*/
    }
  }
  .popup-enter{
    opacity: 0;
    .popup-wrap{
      /*transform: translateY(100%);*/
    }
  }
  .popup-enter-to{
    opacity: 1;
    .popup-wrap{
      /*transform: translateY(0);*/
    }
  }
  .popup-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    .popup-wrap{
      /*transform: translateY(100%);*/
    }
  }
}
</style>
